import React from "react";
import KickImage from 'Reuseables/KickImage';
import SUSPENDED from "../../../../images/suspended.png";

const Suspended = (props) => {
  return (
    <div className={`empty-container credit-minus`}>
      <KickImage src={SUSPENDED} />
      <p className={'title'}>Your account is permanently suspended.</p>
      <p className={'bottom-text'}>
        Please contact our customer service for more information your account.
      </p>
    </div>
  )
}

export default Suspended